import React, { Component } from 'react';

type Rating = 1 | 2 | 3 | 4 | 5;

export interface MorningstarSustainabilityRatingProps
{
	rating: Rating
	noTooltip?: boolean
}

export default class MorningstarSustainabilityRating extends Component<MorningstarSustainabilityRatingProps>
{
	render()
	{
		let numString: string;
		switch ( this.props.rating ) {
			case 1:
				numString = 'One';
				break;
			case 2:
				numString = 'Two';
				break;
			case 3:
				numString = 'Three';
				break;
			case 4:
				numString = 'Four';
				break;
			case 5:
				numString = 'Five';
				break;
		}
		return (
			<div 
				className={`ajb-sustainability-globes--${numString.toLowerCase()}`} 
				role="img" 
				aria-label={!this.props.noTooltip ? `Morning Star Sustainability Globes ${numString}` : null}
				data-testid="morningStarSustainabilityRating"
			/>
		);
	}
}